import React, { useEffect, useState } from "react"
import { Link } from "gatsby"

import NavItems from "./navitems"
import Logo from "../static/images/logo.svg"

export default function NavSticky({ onMenuClick, isUlMenuActive }) {
  const [classes, setClasses] = useState("c-page-menu c-page-menu-sm")

  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset > 100) {
        setClasses("c-page-menu c-page-menu-sm c-sticky-page-menu")
      } else {
        setClasses("c-page-menu c-page-menu-sm")
      }
    }
  }, [])

  return (
    <div id="c-page-menu" class={classes}>
      <div id="c-page-menu-wrap" class="c-page-menu-wrap c-page-menu-wrap-sm">
        <div class="container">
          <div class="row">
            <div class="col-12">
              {/* Whole sticky bar is one labelled nav landmark so the logo isn't
                  stray content and it has a unique accessible name distinct from
                  the primary <nav>. Inner menu is a plain .c-navigation div to
                  avoid nesting a second nav landmark. */}
              <nav
                class="c-header__main-info c-header__main-info-sm"
                aria-label="Sticky navigation"
              >
                <div class="c-page-menu--logo c-page-menu--logo-sm">
                  <Link to="/" aria-label="Home">
                    <img src={Logo} class="image-fluid" alt="" />
                  </Link>
                </div>

                <div class="c-header__login-info c-header__login-info-sm ml-auto">
                  <div class="c-navigation c-navigation-md">
                    <ul class="c-navigation--list">
                      <NavItems />
                    </ul>
                  </div>
                </div>

                <button
                  class="c-sticky-hamMenu js-hamDevice"
                  type="button"
                  aria-label="Open menu"
                  onClick={onMenuClick}
                >
                  <span class="transition-med" aria-hidden="true"></span>
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
